<script>
import { BROWSER_TIME } from 'base/config'
import { getScreenSize } from 'common/js/dom'
import Scroll from 'base/scroll/scroll'

const EVENT_CHANGE = 'change'

export default {
  name: 'MyTab',
  components: {
    Scroll,
  },
  props: {
    navList: {
      type: Array,
      default() {
        return []
      },
    },
    currentTabIndex: {
      type: Number,
      default: 0,
    },
    tabNums: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      current: 0,
      itemStyle: {},
    }
  },
  watch: {
    navList() {
      setTimeout(() => {
        this._initTabItemWidth()
        this._initTabListWidth()
      }, BROWSER_TIME)
    },
  },
  created() {
    this._size = getScreenSize()
  },
  mounted() {
    this._initTabItemWidth()
    this._initTabListWidth()
    if (this.currentTabIndex === null) {
      this.current = 0
    } else {
      this.current = this.currentTabIndex
    }
    setTimeout(() => {
      this._adjust(this.current)
    }, 500)
  },
  methods: {
    selectNavHandler(item, index) {
      if (this.current === index) return
      this.current = index
      this._adjust(index)
      this.$emit(EVENT_CHANGE, item, index)
    },
    isCurrentTab(index) {
      return index === this.current
    },
    _initTabItemWidth() {
      let {
        _size: { width },
        tabNums,
        navList,
      } = this

      if (navList.length <= tabNums) {
        tabNums = navList.length
      }
      const itemWidth = Math.min(width, 480) / tabNums //Math.round()
      this.itemWidth = itemWidth
      this.itemStyle = {
        width: `${itemWidth}px`,
      }
    },
    _initTabListWidth() {
      const tabList = this.$refs.tabList
      if (!tabList) return
      const items = tabList.children
      const itemWidth = this.itemWidth
      let width = 0
      for (let i = 0; i < items.length; i++) {
        // width += items[i].clientWidth
        width += itemWidth
      }
      tabList.style.width = `${width + 1}px`
    },
    _adjust(tabId) {
      const { tabNums } = this
      const viewportWidth = this._size.width
      const tabList = this.$refs.tabList
      if (!tabList) return
      const tabListWidth = tabList.clientWidth
      const minTranslate = Math.min(0, viewportWidth - tabListWidth)
      const base = tabNums === 3 ? 3 : 2
      const middleTranslate = viewportWidth / base
      const items = this.$refs.tabList.children
      let width = 0
      this.navList.every((item, index) => {
        if (index === tabId) {
          return false
        }
        width += items[index].clientWidth
        return true
      })
      let translate = middleTranslate - width
      translate = Math.max(minTranslate, Math.min(0, translate))
      this.$refs.scroll.scrollTo(translate, 0, 300)
    },
  },
}
</script>

<template>
  <div class="bf-tab-container">
    <scroll
      v-if="navList.length"
      ref="scroll"
      class="scroll-container"
      :scroll-x="true"
      :listen-scroll="true"
      :data="navList"
    >
      <div class="bf-tab">
        <div ref="tabList" class="bf-tab-wrap">
          <div
            v-for="(item, index) in navList"
            v-if="!item.deleted"
            :key="index"
            class="bf-tab-item"
            :style="itemStyle"
            :class="{ 'bf-tab--active': isCurrentTab(index) }"
            @click.stop="selectNavHandler(item, index)"
          >
            <slot :item="item" :index="index">
              <div class="bf-tab-text">
                {{ item.name }}
              </div>
            </slot>
          </div>
        </div>
      </div>
    </scroll>
  </div>
</template>

<style scoped>
@import 'variable';

.bf-tab {
  display: inline-block;
  position: relative;
  height: 100%;
  .bf-tab-wrap {
    position: relative;
    /*height: 40px;*/
    white-space: nowrap;
    /*      background-color: var(--white-color);*/
    color: #666;
    font-size: 14px;
  }
  .bf-tab-item {
    position: relative;
    display: inline-block;
    /*height: 40px;*/
    text-align: center;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    .bf-tab-text {
      position: relative;
      padding: 12px 5px;
      @apply --text-ellipsis;
    }
  }
  .bf-tab--active {
    /*position: relative;*/
    color: #508cee;
    &:after {
      /*z-index: 2;
        content: '';
        position: absolute;
        left: 50%;
        bottom: 1px;
        width: 22px;
        height: 4px;
        border-radius: 999px;
        background-color: #508cee;
        transform: translateX(-50%);*/
    }
  }
}

.bf-tab-line {
  position: absolute;
  bottom: 0;
  width: 22px;
  height: 4px;
  border-radius: 999px;
  background-color: #508cee;

  transition-property: left;
  transition-duration: 200ms;
}

.bf-tab-contents {
  overflow: hidden;
  .bf-tab-scroller {
    position: relative;
    display: flex;
    width: 100%;
    /*transition-property: transform;
      transition-duration: 0ms;*/

    transition-property: transform;
    transition-duration: 300ms;
  }
  .bf-tab-content {
    overflow: visible;
    width: 100%;
    height: 0;

    -ms-flex-negative: 0;
    flex-shrink: 0;
  }
  .bf-tab-content--active {
    height: auto;
  }
}

.bf-animate-line {
  width: 22px;
  height: 4px;
  border-radius: 999px;
  background-color: #508cee;

  transition: all 0.3s;
}

.bf-tab-container {
  /*height: 40px;*/
}

.scroll-container {
  overflow: hidden;
  width: 100%;
  /*height: 100%;*/
}
</style>